import LogoWithTextUrl from '@assets/logo-with-text.svg';
import styled from '@emotion/styled';
import type { FC } from 'react';
import { Center } from '../MetaComponent';

interface Props {
  height?: number;
}

export const RacemapLogo: FC<Props> = ({ height = 40 }) => {
  return (
    <Container>
      <a href="https://racemap.com/">
        <img src={LogoWithTextUrl} height={height} alt="Racemap Logo" />
      </a>
    </Container>
  );
};

const Container = styled(Center)`
  cursor: pointer;
`;
